import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Table,
  Modal,
  message,
  Select,
} from "antd";
import baseRequest from "../../utils/baseRequest";
import PagesManage from "../../components/PagesManage";
import { useMemo } from "react";
import dayjs from "dayjs";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
const AutoAnwserContent = (props) => {
  const [messageApi, contextHolder] = message.useMessage();
  //控制创建动态modal是否出现
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPagesModalOpen, setIsPagesModalOpen] = useState(false);
  //提交创建动态
  const [form] = Form.useForm();
  const [pagesOptions, setPagesOptions] = useState([]);
  const { TextArea } = Input;
  //表头
  const columns = [
    {
      title: "关键字",
      dataIndex: "keyword",
      key: "keyword",
      width: 200,
      render: (_, record) => {
        console.log(record);
        return (
          <div>
            <span>{record.keyword}</span>
          </div>
        );
      },
    },
    {
      title: "自动回复内容",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "优先级",
      dataIndex: "priority",
      key: "priority",
      width: 120,
      sorter: (a, b) => a.priority - b.priority,
      defaultSortOrder: "ascend",
      sortDirections: ["ascend", "descend"],
      render: (value, record) => {
        return (
          <div>
            <span>
              {value}
              {value > 6 ? "（不展示）" : ""}
            </span>
          </div>
        );
      },
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      render: (value, record) => (
        <span className={value === 1 ? "text-green-400" : "text-red-400"}>
          {value === 1 ? "启用中" : "已关闭"}
        </span>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      width: 200,
      render: (_, record) => {
        return (
          <div>
            <Space>
              <Space.Compact direction="vertical">
                <Button
                  style={{
                    background: record.status === 1 ? "#ff4d4f" : "#1677ff",
                    color: "#fff",
                  }}
                  onClick={() => {
                    // form.setFieldsValue(record);
                    // setIsModalOpen(true);
                    handleSubmit({
                      ...record,
                      status: record.status === 1 ? 0 : 1,
                    });
                  }}
                >
                  {!record.status ? "启动回复" : "关闭回复"}
                </Button>
                <Button
                  style={{ background: "#999", color: "#fff" }}
                  onClick={() => handleDeleteItem(record?.id)}
                >
                  删除回复
                </Button>
              </Space.Compact>
            </Space>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    getPages();
  }, []);
  //创建页面路由
  const getPages = async () => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/frontend_route/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          offset: 0,
          limit: 10,
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      setPagesOptions(_data.data.list);
    } catch (error) {
      console.error(error);
    }
  };
  const handleEditItem = async (id, value) => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/auto_response/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id,
          ...value,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      message.success("更新成功");
      getData();
    } catch (error) {
      console.error(error);
    }
  };
  const handleDeleteItem = async (id) => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/auto_response/delete", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      message.success("更新成功");
      getData();
    } catch (error) {
      console.error(error);
    }
  };
  //获取数据
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(1);
  const [total, setTotal] = useState(0);
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    n_type: 0,
    obj_user_ids: [],
    push_time: dayjs(new Date()),
    params: "",
    pageName: null,
    link: null,
    action: null,
    link_text: null,
    thumbnail: null,
    obj_type: "0",
  });
  const [currentPageName, setCurrentPageName] = useState("");
  const [buttonAble, setButtonAble] = useState(false);

  const currentPagesOptions = useMemo(() => {
    if (!pagesOptions.length) return [];
    const pages = pagesOptions
      .filter((it) => it.desc === "达人空间")
      .map((it) => {
        return {
          label: it.desc,
          value: JSON.stringify(it),
        };
      });
    return pages;
  }, [pagesOptions, formData.action]);

  const getData = async (offset) => {
    if (!more && offset) return;
    try {
      const base = baseRequest();
      const response = await fetch("/op/auto_response/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          offset: 0,
          limit: 20 + offset,
          ...base,
        }),
      });
      const temData = await response.json();
      console.log("response", temData);

      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      const data = temData.data.list.map((it) => ({
        keyword: it.keyword,
        message: it.message,
        priority: it.priority,
        id: it.id,
        status: it.status,
      }));
      setShowData(data);
      if (temData.data.offset > total) {
        setTotal(temData.data.offset);
      }
      setOffset(temData.data.offset);
      setMore(temData.data.more);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getData(0);
  }, []);

  //展示的数据
  const [showData, setShowData] = useState(data);

  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  //关闭弹窗
  const handleCancelModal = () => {
    form.setFieldsValue(formData);
    setIsModalOpen(false);
  };
  const handleSubmit = async (value) => {
    try {
      const base = baseRequest();
      const baseBody = {
        ...value,
      };
      if (value.id) {
        baseBody.id = value.id;
        baseBody.status = value.status;
      }
      const response = await fetch(
        `/op/auto_response/${value.id ? "update" : "create"}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...baseBody,
            ...base,
          }),
        }
      );
      const data = await response.json();
      if (data.ret === -1) {
        alert(data.msg);
        return;
      }
      handleCancelModal();
      message.success(`${value.id ? "更新" : "发布"}成功`);
      getData(0);
    } catch (error) {
      console.error(error);
    }

    form.resetFields();
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <div className="flex justify-between items-center">
        <Button
          type="primary"
          className="mt-4 mb-4 float-right"
          onClick={() => setIsModalOpen(true)}
        >
          新建自动回复内容+
        </Button>
      </div>
      {contextHolder}
      <ConfigProvider locale={zhCN}>
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{
            pageSize: 20,
            showSizeChanger: false,
            total: total,
          }}
          scroll={{ x: "max-content", y: window.innerHeight - 280 }}
          footer={() => (
            <div className="text-gray-400">获得总数：{showData.length}</div>
          )}
          onScroll={(e) => {
            const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;
            console.log(scrollHeight, scrollTop + clientHeight);

            if (scrollTop + clientHeight + 5 >= scrollHeight) {
              getData(offset);
            }
          }}
        />
      </ConfigProvider>

      {/* 重复判断isModalOpen是为了重新渲染ImageUploader和VideoUploader组件 */}
      <Modal
        title={
          form.getFieldValue("id") ? "编辑自动回复消息" : "新建自动回复消息"
        }
        footer={null}
        open={isModalOpen}
        onCancel={handleCancelModal}
        onChange={setFormData}
      >
        <Form
          className="mt-4 flex flex-col"
          form={form}
          onFinish={(value) => {
            handleSubmit(value, form.getFieldValue("id"));
          }}
          layout="vertical"
          initialValues={formData}
          onChange={setFormData}
        >
          <Form.Item
            label="关键字"
            name="keyword"
            rules={[
              {
                required: true,
                message: "请填写关键字",
              },
            ]}
            className="mb-6"
          >
            <Input maxLength={10} placeholder="字数上限为10" />
          </Form.Item>
          <Form.Item
            label="回复内容（上限250字）"
            name="message"
            rules={[
              {
                required: true,
                message: "请填写回复内容",
              },
            ]}
            className="mb-6"
          >
            <TextArea maxLength={250} showCount placeholder="字数上限为250" />
          </Form.Item>
          <Form.Item
            label="优先级"
            name="priority"
            rules={[
              {
                required: true,
                message: "请选择优先级",
              },
            ]}
            className="mb-6"
          >
            <Select placeholder="选择优先级">
              <Select.Option value={1}>1</Select.Option>
              <Select.Option value={2}>2</Select.Option>
              <Select.Option value={3}>3</Select.Option>
              <Select.Option value={4}>4</Select.Option>
              <Select.Option value={5}>5</Select.Option>
              <Select.Option value={6}>6</Select.Option>
              <Select.Option value={0}>不展示</Select.Option>
            </Select>
          </Form.Item>
          <Button type="primary" htmlType="submit" disabled={buttonAble}>
            确认
          </Button>
        </Form>
      </Modal>
      <Modal
        title="页面管理"
        footer={null}
        open={isPagesModalOpen}
        style={{ minWidth: 800 }}
        onCancel={() => setIsPagesModalOpen(false)}
      >
        <PagesManage />
      </Modal>
    </div>
  );
};

export default function Notices() {
  return (
    <div>
      <AutoAnwserContent />
    </div>
  );
}
